(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var cartPage = document.getElementById('cart-page');
  if (!cartPage) return;

  var moneyFormat = cartPage.dataset.moneyFormat || '{{amount}}';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return moneyFormat
      .replace(/\{\{amount\}\}/g, amount)
      .replace(/\{\{amount_with_comma_separator\}\}/g, amount)
      .replace(/\{\{amount_no_decimals\}\}/g, Math.floor(cents / 100));
  }

  function setLoading(index, on) {
    var card = document.getElementById('cart-item-' + index);
    if (card) card.style.opacity = on ? '0.4' : '1';
  }

  function updateDOM(cart) {
    var itemMap = {};
    cart.items.forEach(function (item) {
      itemMap[item.key] = item;
    });

    document.querySelectorAll('[id^="cart-item-"]').forEach(function (card) {
      var lineKey = card.dataset.lineKey;
      var idx = card.id.replace('cart-item-', '');
      var updated = itemMap[lineKey];

      if (!updated) {
        card.remove();
        var row = document.getElementById('summary-item-' + idx);
        if (row) row.remove();
        return;
      }

      var linePrice = document.getElementById('line-price-' + idx);
      if (linePrice) linePrice.textContent = formatMoney(updated.final_line_price);

      var input = document.querySelector('input[data-line-key="' + lineKey + '"]');
      if (input) input.value = updated.quantity;

      var summaryPrice = document.getElementById('summary-price-' + idx);
      if (summaryPrice) summaryPrice.textContent = formatMoney(updated.final_line_price);

      var summaryQty = document.getElementById('summary-qty-' + idx);
      if (summaryQty) summaryQty.textContent = updated.quantity > 1 ? '× ' + updated.quantity : '';
    });

    var totalEl = document.getElementById('cart-total-price');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    var headerTotal = document.getElementById('header-cart-total');
    if (headerTotal) headerTotal.textContent = formatMoney(cart.total_price);

    if (cart.item_count === 0) window.location.reload();
  }

  function changeQuantity(lineKey, index, newQty) {
    setLoading(index, true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: newQty })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) { setLoading(index, false); updateDOM(data); })
      .catch(function () { setLoading(index, false); });
  }

  document.querySelectorAll('.quantity-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var lineKey = btn.dataset.lineKey;
      var index = btn.dataset.index;
      var input = document.querySelector('input[data-line-key="' + lineKey + '"]');
      if (!input) return;
      var current = parseInt(input.value) || 0;
      var newQty = btn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
      input.value = newQty;
      changeQuantity(lineKey, index, newQty);
    });
  });

  var debounceTimers = {};
  document.querySelectorAll('input[data-line-key]').forEach(function (input) {
    input.addEventListener('change', function () {
      var lineKey = input.dataset.lineKey;
      var index = input.dataset.index;
      var newQty = Math.max(0, parseInt(input.value) || 0);
      clearTimeout(debounceTimers[lineKey]);
      debounceTimers[lineKey] = setTimeout(function () {
        changeQuantity(lineKey, index, newQty);
      }, 600);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var header   = document.getElementById('site-header');
  var toggle   = document.getElementById('mobile-menu-toggle');
  var close    = document.getElementById('mobile-menu-close');
  var menu     = document.getElementById('mobile-menu');
  var overlay  = document.getElementById('mobile-menu-overlay');

  function openMenu() {
    menu.classList.remove('translate-x-full');
    overlay.classList.remove('opacity-0', 'pointer-events-none');
    overlay.classList.add('opacity-100');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    menu.classList.add('translate-x-full');
    overlay.classList.add('opacity-0', 'pointer-events-none');
    overlay.classList.remove('opacity-100');
    document.body.style.overflow = '';
  }

  if (toggle) toggle.addEventListener('click', openMenu);
  if (close)  close.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);

  if (header) {
    function updateHeaderBackground() {
      if (window.scrollY > 0) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
    }
    updateHeaderBackground();
    window.addEventListener('scroll', updateHeaderBackground, { passive: true });
  }

  var localeToggle = document.querySelector('.locale-selector-toggle');
  var localeDropdown = document.querySelector('.locale-selector-dropdown');
  var localeChevron = document.querySelector('.locale-chevron');

  if (localeToggle && localeDropdown) {
    localeToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = localeToggle.getAttribute('aria-expanded') === 'true';
      localeToggle.setAttribute('aria-expanded', !isOpen);
      localeDropdown.classList.toggle('opacity-0', isOpen);
      localeDropdown.classList.toggle('pointer-events-none', isOpen);
      localeDropdown.classList.toggle('translate-y-1', isOpen);
      if (localeChevron) localeChevron.style.transform = isOpen ? '' : 'rotate(180deg)';
    });

    document.addEventListener('click', function () {
      localeToggle.setAttribute('aria-expanded', 'false');
      localeDropdown.classList.add('opacity-0', 'pointer-events-none', 'translate-y-1');
      if (localeChevron) localeChevron.style.transform = '';
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-main-sell-section"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.main-way-section').forEach(function (sectionEl) {
    var cartUrl  = sectionEl.dataset.cartUrl || '/cart';
    var langBtns = sectionEl.querySelectorAll('.way-lang-btn');
    var atcBtns  = sectionEl.querySelectorAll('.way-atc-btn');
    var priceEls = sectionEl.querySelectorAll('.way-price-display');

    langBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.dataset.variantId;
        var price     = btn.dataset.price;

        langBtns.forEach(function (b) {
          if (b.dataset.variantId === variantId) {
            b.setAttribute('data-selected', 'true');
          } else {
            b.removeAttribute('data-selected');
          }
        });

        atcBtns.forEach(function (atcBtn) {
          atcBtn.dataset.variantId = variantId;
          atcBtn.disabled = false;
        });

        if (price) {
          priceEls.forEach(function (el) { el.textContent = price; });
        }
      });
    });

    atcBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled || !btn.dataset.variantId) return;

        var variantId    = btn.dataset.variantId;
        var originalText = btn.dataset.label || btn.textContent.trim();
        var loadingText  = btn.dataset.loading || '…';

        atcBtns.forEach(function (b) {
          b.disabled = true;
          b.textContent = loadingText;
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status) {
              atcBtns.forEach(function (b) {
                b.textContent = originalText;
                b.disabled = false;
              });
            } else {
              window.location.href = cartUrl;
            }
          })
          .catch(function () {
            atcBtns.forEach(function (b) {
              b.textContent = originalText;
              b.disabled = false;
            });
          });
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var article = document.querySelector('[data-money-format]');
  var moneyFormat = article ? article.dataset.moneyFormat : '{{amount}}';
  var cartUrl = article ? article.dataset.cartUrl : '/cart';

  function formatMoney(cents) {
    if (!cents) return '';
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return moneyFormat
      .replace(/\{\{amount\}\}/g, amount)
      .replace(/\{\{amount_with_comma_separator\}\}/g, amount)
      .replace(/\{\{amount_no_decimals\}\}/g, Math.floor(cents / 100));
  }

  // --- Thumbnail switcher ---
  var mainImg = document.getElementById('product-main-image');
  document.querySelectorAll('.product-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImg) {
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.dataset.alt || '';
      }
      document.querySelectorAll('.product-thumb').forEach(function (t) {
        t.classList.remove('product-thumb--active');
      });
      thumb.classList.add('product-thumb--active');
    });
  });

  // --- Quantity stepper ---
  var qtyInput = document.getElementById('product-qty-input');
  var qtyMinus = document.getElementById('product-qty-minus');
  var qtyPlus  = document.getElementById('product-qty-plus');

  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value) || 1;
      qtyInput.value = Math.max(1, v - 1);
    });
  }
  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value) || 1;
      qtyInput.value = v + 1;
    });
  }

  // --- Variant price update ---
  var variantSelect = document.getElementById('product-variant-select');
  var priceEl        = document.getElementById('product-price');
  var comparePriceEl = document.getElementById('product-compare-price');
  var atcBtn         = document.getElementById('product-atc-btn');

  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (priceEl) priceEl.textContent = formatMoney(parseInt(opt.dataset.price));
      if (comparePriceEl) {
        var cp = parseInt(opt.dataset.comparePrice);
        if (cp && cp > parseInt(opt.dataset.price)) {
          comparePriceEl.textContent = formatMoney(cp);
          comparePriceEl.classList.remove('hidden');
        } else {
          comparePriceEl.textContent = '';
          comparePriceEl.classList.add('hidden');
        }
      }
      if (atcBtn) {
        var available = opt.dataset.available === 'true';
        atcBtn.disabled = !available;
        atcBtn.textContent = available ? atcBtn.dataset.label : atcBtn.dataset.soldOutLabel;
      }
    });
  }

  // --- AJAX add to cart ---
  var productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm && atcBtn) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantId = variantSelect
        ? variantSelect.value
        : (productForm.querySelector('input[name="id"]') || {}).value;
      var qty = parseInt((qtyInput || {}).value) || 1;
      var originalLabel = atcBtn.textContent.trim();

      atcBtn.disabled = true;
      atcBtn.textContent = '…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            atcBtn.disabled = false;
            atcBtn.textContent = originalLabel;
          } else {
            window.location.href = cartUrl;
          }
        })
        .catch(function () {
          atcBtn.disabled = false;
          atcBtn.textContent = originalLabel;
        });
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
